import React, { useCallback, useEffect, useState } from "react";

import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom"
import logo from "../../assets/image/pdam.png";
import { clearCache, getCache } from "../../util/Cache";
import { ArrowLeft } from "lucide-react";



export default function HomeMobile(): React.ReactElement {
  const navigate = useNavigate();
  const location = useLocation();
  const routeState = location.state;
  const hasSegelModal = location.pathname === "/mobile/segel" &&
    routeState !== null &&
    typeof routeState === "object" &&
    "segelModalStack" in routeState &&
    Array.isArray(routeState.segelModalStack) &&
    routeState.segelModalStack.length > 0;

  const checkUserDashboard = async (): Promise<boolean> => {
    try {
      const data = await getCache("current_user");
      if (!data || (!data.username && !data.nama)) {
        navigate("/login", { replace: true });
        return false;
      }
      return true;
    } catch (error) {
      navigate("/login", { replace: true });
      return false;
    }
  };

  const handleSignOut = async () => {
    clearCache('current_user');
    navigate("/login");
  }

  const handleUser = async () => {
    await checkUserDashboard();
  }

  useEffect(() => { handleUser(); }, []);
 
  return (
    <div className="min-h-screen min-h-[100dvh] w-full bg-slate-200 flex items-center justify-center sm:p-6">
      <div className="flex h-screen h-[100dvh] w-full max-w-sm flex-col overflow-hidden bg-slate-50 sm:h-[812px] sm:rounded-[2.5rem] sm:border-8 sm:border-slate-900 sm:shadow-2xl">
        <div className="flex items-center gap-3 border-b border-slate-200 bg-white px-5 py-3">
          {/* <Logo className="h-9 w-9" /> */}
          <img src={logo} alt="Logo" className="h-9 w-9 w-auto object-contain center" />
          <div className="leading-tight">
            <p className="text-[11px] font-bold uppercase tracking-wide text-blue-900">
              SIMPEG
            </p>
            <p className="text-[10px] text-slate-800">
              Perumdam Tirta Moolango
            </p>
          </div>
          <div className="ml-auto">
            <button className="rounded-full bg-red-500 px-3 py-1 text-[10px] font-semibold uppercase text-white shadow-sm hover:bg-red-600" onClick={handleSignOut}>
              Sign Out
            </button>
          </div>
        </div>

        <Outlet />

        {
          location.pathname !== "/mobile" ?
          <footer
            className="flex shrink-0 justify-center border-t border-gray-200 bg-white px-4 pt-3"
            style={{ paddingBottom: 'calc(0.75rem + env(safe-area-inset-bottom, 0px))' }}
          >
              <button
                  type="button"
                  onClick={() => hasSegelModal ? navigate(-1) : navigate("/mobile")}
                  aria-label={hasSegelModal ? "Tutup modal" : "Kembali ke menu utama"}
                  className="flex items-center gap-2 rounded-full border border-gray-200 bg-white px-6 py-2.5 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 active:bg-gray-100"
              >
                  <ArrowLeft className="h-4 w-4" />
                  Kembali
              </button>
          </footer> : ""
        }

      </div>
    </div>
  );
}